import axios from 'axios';
import Config from '../actions/Config';
// import RefreshToken from '../actions/RefreshToken';
import AccessToken from '../actions/AccessToken';

const BASE_URL = Config();
const getResponse = {};
const token = AccessToken();

// console.log("jstoken", token);
getResponse.GetProjectList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetEntityDropdown = (accesstoken, endpoint, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response.data.data);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetTaskDropdown = (accesstoken, endpoint, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response.data.data);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetAssignDropdown = (accesstoken, endpoint, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response)
        console.log("res", response.data.data);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetProjectDetails = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        if(error.response) {
            callback(error.response);
        }
    })
} 
getResponse.CreateProject = (data, accesstoken, callback) => {
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accesstoken}` },
        data: data,
        url: `${BASE_URL}/api/Project/addproject`,
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.EditProject = (data, id, accesstoken, callback) => {
    axios({
        method: 'PUT',
        headers: { Authorization: `Bearer ${accesstoken}` },
        data: data,
        url: `${BASE_URL}/api/Project/edit/${id}`,
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}
getResponse.RestoreProject = (id, accesstoken, callback) => {
    axios({
        method: 'PUT',
        headers: { Authorization: `Bearer ${accesstoken}` },
        url: `${BASE_URL}/api/Project/restore/${id}`,
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}
getResponse.DeleteProject = (endpoint, accesstoken, callback) => {
    console.log("${BASE_URL}${endpoint}", `${BASE_URL}${endpoint}`);
        axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetTaskList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetFilesList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetFormList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetDiscussion = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.CreatePost = (data, accesstoken, endpoint, callback) => {
    console.log(`${BASE_URL}${endpoint}`);
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accesstoken}` },
        data: data,
        url: `${BASE_URL}${endpoint}`,
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetRoleDropdown = (accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}/api/roles`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response)
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetUserDropdown = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response)
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.CreateTask = (data, endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accesstoken}` },
        data: data,
        url: `${BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.CompleteTask = (data, accesstoken, endpoint, callback) => {
    axios({
        method: 'POST',
        headers: { Authorization: `Bearer ${accesstoken}` },
        data: data,
        url: `${BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.DeleteTask = (endpoint, accesstoken, callback) => {
    axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.DeleteFile = (endpoint, accesstoken, callback) => {
    axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.DeleteForm = (endpoint, accesstoken, callback) => {
    axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.UploadFiles = (endpoint, formdata, accesstoken, callback) => {
    axios({
        method: 'POST',
        data: formdata,
        url:`${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        console.log("responseupload", response)
        callback(response)
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.MultipleUploadFiles = (endpoint, formdata, accesstoken, onUploadProgress) => {
    return axios({
        method: 'POST',
        data: formdata,
        url:`${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
        onUploadProgress
    })
} 
getResponse.EditTask = (data, endpoint, accesstoken, callback) => {
    axios({
        method: 'PUT',
        data: data,
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetTaskDetails = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.GetProjectReportList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        // RefreshToken();
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getResponse.ProjectClone = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}

export default getResponse;
